import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

import { Wrapper } from './QuizLinkButton.styles';

import { Icon } from '@/components/Icon';

type Props = {
  onClick: () => void;
};

export const QuizLinkButton: React.FC<Props> = ({ onClick }) => {
  const { t } = useTranslation('CourseTranslations');

  return (
    <div onClick={onClick}>
      <Tooltip title={t('QUIZ_LINK_BUTTON')}>
        <Wrapper>
          <Icon i="View" size={16} />
        </Wrapper>
      </Tooltip>
    </div>
  );
};
